// extracted by mini-css-extract-plugin
export default {"header_container":"VoiceList_header_container__vxcdn","action_container":"VoiceList_action_container__uOfWg","table_action_container":"VoiceList_table_action_container__apGkr"};